"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextChips = void 0;

var _react = _interopRequireDefault(require("react"));

var _TextChipsInput = require("./TextChipsInput");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const TextChips = ({
  value,
  onChange,
  dropdownOptions,
  dropdownWidth,
  width,
  label,
  renderChip,
  dropdownPadding,
  showArrowIcon
}) => {
  return /*#__PURE__*/_react.default.createElement(_TextChipsInput.TextChipsInput, {
    value: value,
    onChange: onChange,
    dropdownOptions: dropdownOptions,
    dropdownWidth: dropdownWidth,
    chipsAlign: 'horizontal',
    showRemoveIcon: false,
    width: width,
    label: label,
    showArrowIcon: showArrowIcon,
    renderChip: renderChip,
    labelMargin: "8px",
    dropdownPadding: dropdownPadding
  });
};

exports.TextChips = TextChips;
TextChips.propTypes = {
  /** chips contain width */
  width: _propTypes.default.string,

  /** A Dropdown options width */
  dropdownWidth: _propTypes.default.string,

  /** An array of options that represents the value for Options */
  dropdownOptions: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    id: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
    value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool])
  })),

  /** An array of data that represents the value of the chips */
  value: _propTypes.default.array.isRequired,

  /** A function called when the value of chips changes, passes the chips value as an argument. */
  onChange: _propTypes.default.func.isRequired,

  /** For custom chip usage. A function that passes the value of the chip as an argument, must return an element that will be rendered as each chip. */
  renderChip: _propTypes.default.func,

  /** For custom Options usage. A function that passes the option of the dropdown as an argument, must return an element that will be rendered as each option. */
  renderDropdownOptions: _propTypes.default.func,

  /** A Field for Multi Select Label*/
  label: _propTypes.default.string,

  /** For custom field for dropdown container padding. */
  dropdownPadding: _propTypes.default.string,

  /** A Field to enable dropdown Icons*/
  showArrowIcon: _propTypes.default.bool
};
TextChips.defaultProps = {
  chipsAlign: 'vertical',
  width: '100%',
  dropdownWidth: '80%',
  value: [{
    label: 'label1',
    id: 'label1',
    value: 'label1'
  }],
  showRemoveIcon: true,
  showArrowIcon: true,
  label: 'Label',
  dropdownPadding: '14px 24px'
};